import { render } from "./ManualAnnotationView.vue?vue&type=template&id=cd706d36"
import script from "./ManualAnnotationView.vue?vue&type=script&lang=js"
export * from "./ManualAnnotationView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__